import React, { PureComponent } from "react";
import Link from "gatsby-link";
import cx from "classnames";
import Icon from "./Icon";

const CaseStudyBlock = ({ allPages, currentPage }) =>
  <div className="fixed vh-100 w-100">
    <div className="flex flex-column flex-row-l h-100 w-100">
      <div
        className={cx(
          "h-100 flex flex-column bg-red-dark justify-center relative w-100 w-50-l ph2 pb2 ph3-m pb3-m ph5-l pb4-l ease-reg",
          {
            "bg-orange": currentPage.id == "about",
            "bg-rust": currentPage.id == 1,
            "bg-aqua": currentPage.id == 2,
            "bg-sand": currentPage.id == 3
          }
        )}
        style={{
          backgroundImage: `url(${require("../images/background-shape.png")})`,
          backgroundSize: "cover"
        }}
      >
        <div
          className={cx("absolute bottom-0 pb2 pb3-m pb4-l o-0 ease", {
            "o-100": currentPage.id == "about"
          })}
        >
          <Icon name="down-arrow" />
        </div>
      </div>
      <div
        className={cx("w-100 w-50-l ease-reg relative", {
          "bg-orange": currentPage.id == "about",
          "bg-rust": currentPage.id == 1,
          "bg-aqua": currentPage.id == 2,
          "bg-sand": currentPage.id == 3
        })}
      >
        <div
          className={cx(
            "absolute absolute--fill o-0 ease-opacity cover bg-center",
            {
              "o-100": currentPage.id == "about"
            }
          )}
          style={{
            backgroundImage: `url("${allPages[0].headerPhoto}")`
          }}
        />
        <div
          className={cx(
            "absolute absolute--fill o-0 ease-opacity cover bg-center",
            {
              "o-100": currentPage.id == 1
            }
          )}
          style={{
            backgroundImage: `url("${allPages[1].headerPhoto}")`
          }}
        />
        <div
          className={cx(
            "absolute absolute--fill o-0 ease-opacity cover bg-center",
            {
              "o-100": currentPage.id == 2
            }
          )}
          style={{
            backgroundImage: `url("${allPages[2].headerPhoto}")`
          }}
        />
        <div
          className={cx(
            "absolute absolute--fill o-0 ease-opacity cover bg-center",
            {
              "o-100": currentPage.id == 3
            }
          )}
          style={{
            backgroundImage: `url("${allPages[3].headerPhoto}")`
          }}
        />
      </div>
    </div>
  </div>;

export default CaseStudyBlock;



// WEBPACK FOOTER //
// ./src/components/CaseStudyBlock.js